import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CORE_API_URL } from '../../app.constants';

import { Organization } from './organization.model';
import { createRequestOption } from '../../shared';

type EntityResponseType = HttpResponse<Organization>;
type EntityArrayResponseType = HttpResponse<Organization[]>;

@Injectable()
export class OrganizationService {

    private resourceUrl =  CORE_API_URL + '/v1/organizations';

    constructor(private http: HttpClient) { }

    create(organization: Organization): Observable<EntityResponseType> {
        const copy = this.convert(organization);
        return this.http.post(this.resourceUrl, copy, { observe: 'response' });
    }

    update(organization: Organization): Observable<EntityResponseType> {
        const copy = this.convert(organization);
        return this.http.put(this.resourceUrl, copy, { observe: 'response' });
    }

    find(id: number): Observable<EntityResponseType> {
        return this.http.get(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }

    query(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http.get<Organization[]>(this.resourceUrl, { params: options, observe: 'response' });
    }

    delete(id: number): Observable<Object> {
        return this.http.delete(`${this.resourceUrl}/${id}`);
    }

    /**
     * Convert a Organization to a JSON which can be sent to the server.
     */
    private convert(organization: Organization): Organization {
        const copy: Organization = Object.assign({}, organization);
        return copy;
    }
}
